<template>
  <div id="wap" ref='wap' class="wap_app" :style="{height:screenHeight+'px'}">
    <navBar @navChang="navChang" :activeIndex="activeIndex"></navBar>
    <div class="swiper wap_Swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <banner-view id="bannerView"></banner-view>
        </div>
        <div class="swiper-slide">
          <hzFlow id="hzFlow"></hzFlow>
        </div>
        <div class="swiper-slide">
          <hzTwo id="hzTwo"></hzTwo>
        </div>
        <div class="swiper-slide">
          <hzCase id="hzCase"></hzCase>
        </div>
        <div class="swiper-slide">
          <yqjs id="yqJs"></yqjs>
        </div>
        <div class="swiper-slide">
          <business id="business"></business>
        </div>
        <div class="swiper-slide">
          <sqshow id="sqshow "></sqshow>
        </div>
        <div class="swiper-slide">
          <game-single id="gameSingle"></game-single>
        </div>
        <div class="swiper-slide">
          <download id="downloadGame" @update="handleOpen"></download>
        </div>
      </div>
    </div>
    <div class="sign" v-if="wapSwiperIndex < 8" @click="below"></div>
    <!-- 下载引导页 -->
    <guide ref="guideopen"></guide>
  </div>
</template>
<script>
import download from "./wap_components/download";
import navBar from "./wap_components/navBar";
import BannerView from "./wap_components/bannerView";
import hzFlow from "./wap_components/hzFlow.vue";
import hzTwo from "./wap_components/hzTwo.vue";
import hzCase from "./wap_components/hzCase.vue";
import yqjs from "./wap_components/yqjs.vue";
import business from "./wap_components/business.vue";
import sqshow from "./wap_components/sqshow.vue";
import GameSingle from "./wap_components/gameSingle.vue";
import { callApp,location } from "@/utils/download";
import { qywx, WXTest, qq,iosModel } from "@/utils/guidance";
import Guide from './guide/guide.vue';

export default {
  components: {
    navBar,
    download,
    BannerView,
    hzFlow,
    hzTwo,
    hzCase,
    yqjs,
    business,
    sqshow,
    GameSingle,
    Guide,
  },
  data() {
    return {
      screenHeight:0,
      wapNavList: [],
      slideSwiper: null,
      activeRed: null,
      activeIndex: null,
      id: 0,
      wapSwiperIndex: 0,
      isshow: false,
      wapNavList: [
        {
          show: true,
          title: "首页",
        },
        {
          show: false,
          title: "合作流程",
        },
        {
          show: false,
          title: "引擎介绍",
        },
        {
          show: false,
          title: "商务合作",
        },
        {
          show: false,
          title: "授权展示",
        },
        {
          show: false,
          title: "游戏专区",
        },
        {
          show: false,
          title: "下载中心",
        },
        {
          show: false,
          url: "https://www.qn000.com",
          special: true,
        },
      ],
      list: [
        { id: 0 }, // 首页
        { id: 1 }, // 合作
        {},
        {},
        { id: 2 }, // 引擎
        { id: 3 }, // 商务合作
        { id: 4 }, // 授权
        { id: 5 }, //游戏专区
        { id: 6 }, //下载
      ],
      navList: [
        { id: 0 }, // 首页
        { id: 1 }, // 合作
        { id: 4 }, // 引擎
        { id: 5 }, // 商务合作
        { id: 6 }, // 授权
        { id: 7 }, //游戏专区
        { id: 8 }, //下载
      ],
    };
  },
  created() {
    this.screenHeight = window.innerHeight;
    // 如果需要监听窗口大小变化，可以添加事件监听器
    window.addEventListener('resize', this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      this.wapSwiper();
    });
  },
  beforeDestroy(){
     // 组件销毁前移除事件监听器
     window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize(){
      this.screenHeight = window.innerHeight;
    },
    below() {
      this.wapSwiperIndex = this.wapSwiperIndex + 1;
      this.slideSwiper.slideTo(this.wapSwiperIndex, 1000, false);
      this.activeIndex = this.list[this.wapSwiperIndex];
    },
    
    handleOpen(number, value) {
      if (qywx || qq || WXTest) {
        this.$refs.guideopen.show = value;
      }else if(number==2){
        location(PC_URL)
      } else {
        if (iosModel) {
          callApp(`${iosbag}=?type=universal&url/pages/index/index`, 2400)
            .then()
            .catch(() => {
              location(IOS_URL)
            });
          
        } else {
          let url = ANDROID_URL
          if(number==9){
            url = ANDROID_URL_MN
          }

          callApp(`${Androidbag}=?type=universal&url/pages/index/index`, 2400)
            .then()
            .catch(() => {
              location(url)
            });
        }
      }
    },
    navChang(index) {
      // 这个id是点击navBar对应的下标   slideTo(页面的位置，就算轮播silde的长度)
      this.slideSwiper.slideTo(this.navList[index].id);
    },

    basescroll(id) {
      let dome = document.querySelector(id);
      dome.scrollIntoView();
    },
    wapSwiper() {
      let _this = this;
      _this.slideSwiper = new Swiper(".wap_Swiper", {
        direction: "vertical",
        // slidesOffsetBefore : 0,
        // loop:false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper，主要是这两行
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          slideChangeTransitionStart: function () {
            console.log(this.activeIndex, "this.activeIndex;");
            _this.activeRed = this.activeIndex;
            _this.activeIndex = _this.list[this.activeIndex];
            _this.wapSwiperIndex = this.activeIndex;
          },
        },
      });
    },
  },
 
};
</script>
<style lang="scss" scoped>
@import url("../assets/css/wap_index.css");
// @import url('../assets/css/wap_index_600.css');
#wap {
  width: 100%;
  // position: fixed;
  // display: block;
  height: 100vh;
  // display: flex;
  // flex-direction: column;
}

.wap_Swiper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.swiper-slide {
  width: 100%;
  height: 100%;
  // flex-shrink: 0;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
